module.exports = __webpack_public_path__ + "static/media/LoaderRectangle.8e9a0fad.svg";